<template>
  <div>
    <div class="page">
      <div class="page__bd">
        <div class="weui-cells">
          <div class="weui-cell weui-cell_access">
            <div class="weui-cell__hd">
              <label for class="weui-label">姓名</label>
            </div>
            <div class="weui-cell__bd"></div>
            <div class="weui-cell__ft">{{form.realname || '无'}}</div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">部门</label>
            </div>
            <div class="weui-cell__bd"></div>
            <div class="weui-cell__ft">
              <span
                class="list-item-status"
                v-for="dept in departments"
                :key="dept.id"
              >{{dept.dp_name}}</span>
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">岗位</label>
            </div>
            <div class="weui-cell__bd"></div>
            <div class="weui-cell__ft">
              <span class="list-item-status" v-for="role in roles" :key="role.id">{{role.name}}</span>
            </div>
          </div>
        </div>

        <div class="weui-cells">
          <div class="weui-cell weui-cell_access">
            <div class="weui-cell__hd">
              <label for class="weui-label">手机</label>
            </div>
            <div class="weui-cell__bd"></div>
            <div class="weui-cell__ft">{{form.mobile || '无'}}</div>
          </div>
          <div class="weui-cell weui-cell_access">
            <div class="weui-cell__hd">
              <label for class="weui-label">邮箱</label>
            </div>
            <div class="weui-cell__bd"></div>
            <div class="weui-cell__ft">{{form.email || '无'}}</div>
          </div>
        </div>

        <div class="weui-cells">
          <router-link class="weui-cell weui-cell_access" to="/security/password">
            <div class="weui-cell__hd">
              <label for class="weui-label">密码</label>
            </div>
            <div class="weui-cell__bd"></div>
            <div class="weui-cell__ft">修改</div>
          </router-link>
        </div>
        <!-- <div class="weui-cells">
          <router-link class="weui-cell weui-cell_access" to="/sign/info">
            <div class="weui-cell__hd">
              <label for class="weui-label">电子签名</label>
            </div>
            <div class="weui-cell__bd"></div>
            <div class="weui-cell__ft">设置</div>
          </router-link>
        </div> -->
        <div class="weui-cells">
          <router-link class="weui-cell weui-cell_access" to="/document/employee_edit_current">
            <div class="weui-cell__hd">
              <label for class="weui-label">个人档案</label>
            </div>
            <div class="weui-cell__bd"></div>
            <div class="weui-cell__ft">修改</div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {},
      roles: [],
      departments: []
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.loadData();
    });
  },
  methods: {
    loadData() {
      var me = this;
      me.$ajax({
        url: "/api/auth/info"
      }).then(function(res) {
        if (res.success) {
          var account = res.data.account;
          me.form = account;
          if (account.departsMap) {
            me.departments = account.departsMap[account.companyId];
          }
          if (account.rolesMap) {
            me.roles = account.rolesMap[account.companyId];
          }
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    }
  }
};
</script>